import { type SSOContentProps } from "../SingleSignOnComponent";
import { AnnouncingHeader } from "../AnnouncingHeader/AnnouncingHeader";
import { LogoComponent } from "../LogoComponent/LogoComponent";

const SSOContentComponent = ({
  messages,
  verificationService,
  updateViewModelAndOpenLoginTab,
  dashedStepName,
}: SSOContentProps) => (
  <div className="sid-header sid-l-horz-center">
    <div className={`sid-${dashedStepName}-logo-container sid-l-horz-center`}>
      <LogoComponent
        verificationService={verificationService}
        fallbackLogo={
          <img
            className={`sid-${dashedStepName}-logo-default sid-l-lead-image`}
            alt=""
            src="https://assets-resources.sheerid.com/common/images/2018/icons/sso-step.svg"
          />
        }
      />
    </div>
    <AnnouncingHeader align="center">{messages.title}</AnnouncingHeader>
    <div className="sid-header__subtitle-one">{messages.subtitle}</div>
    <div
      className={`sid-form-region sid-${dashedStepName}-submit sid-submit-wrapper sid-l-space-top-md`}
    >
      <button
        id={`sid-submit-btn-${dashedStepName}`}
        onClick={() => updateViewModelAndOpenLoginTab("isSingleSignOnActive", true)}
        type="submit"
        className={`sid-btn sid-${dashedStepName}-submit-btn sid-btn--dark sid-l-full-width`}
        aria-label="submit"
      >
        {messages.login}
      </button>
    </div>
    <div className="sid-l-space-top-lg" />
  </div>
);
export { SSOContentComponent };
